import * as THREE from "three";
import {
  mergeMap,
  groupBy,
  filter,
  distinctUntilKeyChanged,
} from "rxjs/operators";

export const SpriteSystem = (world, props = {}) => {
  world.data.entity$
    .pipe(
      groupBy(
        (entity) => entity.id,
        (entity) => entity
      ),

      mergeMap((group$) =>
        group$.pipe(
          filter(
            (entity) =>
              entity.hasOwnProperty("object3D") &&
              entity.object3D &&
              entity.hasOwnProperty("sprite") &&
              entity.sprite
          ),
          distinctUntilKeyChanged("sprite")
        )
      )
    )

    .subscribe((entity) => {
      const sprite = new THREE.Sprite();
      world.object3DManager.setObject3D(entity.object3D, sprite);
    });
};

export default SpriteSystem;
